"use client";

import { NestedHome } from "@habity/types";
import { HomeProfileCTAs } from "./components/CTAs";
import { PageFooter } from "~/components/ui/page/footer";

interface HomeProfileFooterProps {
  home: NestedHome;
}

export function HomeProfileFooter({ home }: HomeProfileFooterProps) {
  return (
    <PageFooter>
      <HomeProfileCTAs home={home} />
    </PageFooter>
  );
}
